import React, { FC, useCallback } from 'react';
import { Api, ButtonStroke } from '@blink/components';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useActivateYourVaultStyle } from './ActivateYourVaultModal.style';
import { PATHS } from 'src/routes/paths';
import { useModal } from '../../ModalWrapperHooks';
import { OperationStatusType } from '../../../../features/Modals/ui/OperationStatusModal';

import { showModalAction } from '@/shared/store/modals/actions';
import { ModalName } from '@/shared/store/modals/constants';
import { Store } from '@/shared/store';
import { useWalletContract } from '@/shared/hooks/useWalletContract';
import DispatcherABI from '@/shared/abi/DispatcherABI.json';

type ActivateYourVaultModalProps = {
    address?: string;
};

export const ActivateYourVaultModal: FC<ActivateYourVaultModalProps> = () => {
    const classes = useActivateYourVaultStyle();

    const navigate = useNavigate();

    const vaults = useSelector((state: Store) => state.vaults.vaults);

    const { modalProps, onClose } = useModal();

    const { vault, address, isSuspend } = modalProps;

    const currentVault = vaults?.find((vault) => vault.address === address);

    const dispatcherAddress = Api.APP_DISPATCHER_ADDRESS;

    const dispatcher = useWalletContract({
        address: dispatcherAddress,
        abi: DispatcherABI,
    });

    const dispatch = useDispatch();

    const handleActivateVault = useCallback(async () => {
        try {
            const amount = await vault.totalDeposited();

            await dispatcher?.registerAccount(address, [], {
                token: currentVault?.leverage?.address,
                amount,
            });

            dispatch(
                showModalAction({
                    modalName: ModalName.VAULT_IS_BEEN_ACTIVATED_MODAL,
                    modalProps: {
                        address,
                        isSuspend,
                        onClose,
                    },
                    onClose: () => navigate(`${PATHS.VAULTS_MANAGE}`),
                }),
            );
        } catch (error) {
            dispatch(
                showModalAction({
                    modalName: ModalName.OPERATION_STATUS_MODAL,
                    modalProps: {
                        type: OperationStatusType.Error,
                        title: 'Vault Activated Error',
                        description:
                            'An error occurred while activating the vault. Please try again.',
                        closable: true,
                        withoutButton: true,
                    },
                    onClose,
                }),
            );

            console.error('Error activating vault', error);
        }
    }, [vault, dispatcher]);

    return (
        <div className={classes.wrapper}>
            <ButtonStroke
                className={classes.button}
                onClick={handleActivateVault}
                isPrimary={true}
                disabled={!dispatcher || !vault}
            >
                Activate
            </ButtonStroke>
        </div>
    );
};
